<!-- Hide button completely for Reader role (they can't create anything) -->
<button mat-stroked-button 
        [matMenuTriggerFor]="quickCreateMenu" 
        matTooltip="Crear nuevo" 
        class="quick-create-button"
        *hasRole="['admin', 'project_manager', 'writer']">
    <mat-icon [svgIcon]="'heroicons_outline:plus-circle'"></mat-icon>
    <span class="ml-2">Crear Nuevo</span>
</button>

<mat-menu #quickCreateMenu="matMenu" xPosition="after">
    <!-- Admin or Project Manager can create projects -->
    <button mat-menu-item (click)="createProject()" *hasRole="['admin', 'project_manager']">
        <mat-icon [svgIcon]="'heroicons_outline:clipboard-document-check'"></mat-icon>
        <span>Nuevo Proyecto</span>
    </button>

    <!-- Admin, PM, and Writer can create honeytokens (if they have write permission) -->
    <button mat-menu-item (click)="createHoneytoken()" *hasRole="['admin', 'project_manager', 'writer']">
        <mat-icon [svgIcon]="'heroicons_outline:sparkles'"></mat-icon>
        <span>Nuevo Honeytoken</span>
    </button>

    <!-- Only Admin can create users -->
    <button mat-menu-item (click)="createUser()" *hasRole="'admin'">
        <mat-icon [svgIcon]="'heroicons_outline:user'"></mat-icon>
        <span>Nuevo Usuario</span>
    </button>
</mat-menu>